import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification } from "antd";
import { ConfirmAbortModal } from "@ts-digital/vrc";
import { openNotificationWithIcon } from "../../libs/utils";
import { removeDocument } from "../../store/actions/detailsDocument/index";
import { FormattedMessage } from "react-intl";

const DeleteButton = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,    
    myType
  } = props;
  const navigate = useNavigate();
  const [isVisibleRemoveModal, setIsVisibleRemoveModal] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const detailsDocument = useSelector(state => state.detailsDocument);

  const info = detailsDocument.info;

  const macroCategory = info.details
    ? info.details.standardTags.find(el => {
      return el.key === "macrocategory";
    })
    : null;

  // i clienti possono cancellare solo la categoria inbox. Quindi non c'è tasto se non è verificata la condizione
  if (myType !== "STUDIO" && macroCategory && macroCategory.value !== "Inbox")
    return null;

  // il commercialista può cancellare qualsiasi file non uguale a fature elettroniche
  if (info.details && info.details.einvoice) return null;

  return ( /* detailsDocument.isDocRemoved.started ? (
    <FontAwesomeIcon
      icon={["fas", "circle-notch"]}
      style={{ color: "#d82829", width: "12px" }}
      spin
    />
  ) :  */
    <React.Fragment>
      <div
        className="gs-documents-detail-delete"
        style={{
          cursor: "pointer",
          paddingRight: "10px",
          marginRight: "40px",
          display: "inline-block",
          color: "#d82829"
        }}
        onClick={() => {
          setIsVisibleRemoveModal(true);
        }}
      >
        <FontAwesomeIcon
          icon={["far", "trash-alt"]}
          style={{ color: "#d82829", fontSize: "16px" }}
        />
        <span style={{ marginLeft: "8px" }}>
          {" "}
          <FormattedMessage id="actions.delete" />{" "}
        </span>
      </div>

      <ConfirmAbortModal
        visible={isVisibleRemoveModal}
        title={<FormattedMessage id="documents.delete.title" />}
        onAbort={() => setIsVisibleRemoveModal(false)}
        onConfirm={() => {
          setIsVisibleRemoveModal(false);
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:DOCUMENT_DELETE");
          }
          dispatch(removeDocument(
            auth,
            accountantSelected,
            accountantIdSelected,
            companySelected,
            clientIdSelected,
            info.details.documentId
          ))
            .then(() => {
              openNotificationWithIcon(
                notification,
                "success",
                <FormattedMessage id="documents.delete.feedback.okTitle" />,
                <FormattedMessage id="documents.delete.feedback.okMessage" />,
                <FontAwesomeIcon
                  icon={["fas", "check-circle"]}
                  style={{ color: "#09822a" }}
                />,
                navigate("/documenti"),
                10
              );
            })
            .catch(() => {
              openNotificationWithIcon(
                notification,
                "error",
                <FormattedMessage id="documents.delete.feedback.koTitle" />,
                <FormattedMessage id="documents.delete.feedback.koMessage" />,
                <FontAwesomeIcon
                  icon={["fas", "minus-circle"]}
                  style={{ color: "#d82829" }}
                />,
                () => {},
                10
              );
            });
        }}
        abortText={<FormattedMessage id="documents.delete.no" />}
        confirmText={<FormattedMessage id="documents.delete.confirm" />}
        type={"danger"}
      >
        <div style={{ padding: "30px 0" }}>
          <FormattedMessage id="documents.delete.text" />
        </div>
      </ConfirmAbortModal>
    </React.Fragment>
  );
};

export default DeleteButton;
